import { queryClient } from '../../../../../services/query';
import { DYNAMIC_REPORT_QUERY_PREFIX } from '../../../../scheduled-reports/hooks/useDynamicReportCache';

export const setDynamicReportDataToCache = (reportId, accountId, newData) => {
    queryClient.setQueryData([DYNAMIC_REPORT_QUERY_PREFIX, accountId, reportId], newData);
};
